/** Trailing marker for a field label, denoting a required form field. */
export function RequiredMark() {
  return (
    <span className="text-destructive" aria-hidden>
      {' '}
      *
    </span>
  );
}
